import http from 'lib/utils/axios';

const TRANSACTION_BROWSING_URL = '/partner/transaction-browsing/';

export const create = projectId => http.post(`${TRANSACTION_BROWSING_URL}${projectId}`);
